/* flatoo shipping guidance: default text, supplier-only prefecture selector.
   Draft dates are provisional until origin/transit/closures are verified. */
(function () {
'use strict';
var endpoint='https://reviews.flatoo.jp/shipping-manager/quote/';
var regionEndpoint='https://reviews.flatoo.jp/shipping-manager/geo-prefecture/';
var commercialEndpoint='https://reviews.flatoo.jp/shipping-manager/commercial-preview/';
// 2026-10-13 商材王 supplier lead-time sheet, exact-code-matched product pages.
// C=地域別着日(佐川急便/ヤマト), S=発送予定日のみ(メーカー直送/大川配送)
// D=当日(12:00), B=受付日を1日目とする第5営業日(09:30), R=7～14暦日(12:00).
// Unmatched product codes and pages without a checked shipping policy are excluded.
var commercialRules=Object.create(null);
function addCommercial(handles,mode,policy){
  handles.split(' ').forEach(function(h){if(h)commercialRules[h]={mode:mode,policy:policy};});
}
addCommercial('flt-bed-001 flt-bed-002 flt-bed-003 flt-box-001 flt-box-002 flt-ctb-001 flt-dbx-002 flt-dbx-003 flt-dns-001 flt-dns-002 flt-dsk-002 flt-hsf-001 flt-ktc-003 flt-ktr-001 flt-ktr-002 flt-ktr-007 flt-lbd-002 flt-ldr-001 flt-srk-005 flt-tbl-002 flt-tbl-021 flt-tvb-002','C','D');
addCommercial('flt-dbx-005 flt-tbl-001','C','D');
addCommercial('flt-box-003','C','R');
addCommercial('flt-lbd-001','S','D');
addCommercial('flt-csf-018 flt-csf-020 flt-csf-021 flt-sfb-008','S','B');
addCommercial('flt-csf-014 flt-csf-015 flt-kfs-001 flt-kft-001 flt-ktt-001 flt-otm-001 flt-zch-001','S','R');
function commercialWindow(policy,cutoff){
  var now=jstDate(), accepted=nextBusiness(now.date);
  if(!accepted)return null;
  var matched=/^([01][0-9]|2[0-3]):([0-5][0-9])$/.exec(cutoff||'');
  var limitHour=matched?Number(matched[1]):(policy==='B'?9:12);
  var limitMinute=matched?Number(matched[2]):(policy==='B'?30:0);
  if(accepted.getTime()===now.date.getTime()&&
    (now.hour>limitHour||(now.hour===limitHour&&now.minute>limitMinute))){
    accepted=nextBusiness(add(accepted,1));
  }
  if(!accepted)return null;
  if(policy==='D')return {first:accepted,last:accepted};
  if(policy==='B'){
    var fifth=advance(accepted,4);
    return fifth?{first:fifth,last:fifth}:null;
  }
  if(policy==='R')return {first:add(accepted,7),last:add(accepted,14)};
  return null;
}
function officialCommercialTransit(pref){
  // "出荷から着までのリードタイム" as published by 商材王, 2026-10-13.
  if(pref==='北海道'||pref==='沖縄県')return [3,4];
  if('青森県 岩手県 宮城県 秋田県 山形県 福島県'.split(' ').indexOf(pref)!==-1)return [2,3];
  if('茨城県 栃木県 群馬県 埼玉県 千葉県 東京都 神奈川県'.split(' ').indexOf(pref)!==-1)return [2,2];
  if('新潟県 富山県 石川県 福井県 山梨県 長野県 岐阜県 静岡県 愛知県 三重県 滋賀県 京都府 大阪府 兵庫県 奈良県 和歌山県'.split(' ').indexOf(pref)!==-1)return [1,2];
  if('鳥取県 島根県 岡山県 広島県 山口県 徳島県 香川県 愛媛県 高知県 福岡県 佐賀県 長崎県 熊本県 大分県 宮崎県 鹿児島県'.split(' ').indexOf(pref)!==-1)return [2,2];
  return null;
}

var holidays=new Set(('2026-01-01 2026-01-12 2026-02-11 2026-02-23 2026-03-20 2026-04-29 2026-05-03 2026-05-04 2026-05-05 2026-05-06 2026-07-20 2026-08-11 2026-09-21 2026-09-22 2026-09-23 2026-10-12 2026-11-03 2026-11-23 2027-01-01 2027-01-11 2027-02-11 2027-02-23 2027-03-21 2027-03-22 2027-04-29 2027-05-03 2027-05-04 2027-05-05 2027-07-19 2027-08-11 2027-09-20 2027-09-23 2027-10-11 2027-11-03 2027-11-23').split(' '));
function add(d,n){return new Date(d.getTime()+n*86400000);}
function business(d){return d.getUTCDay()>0&&d.getUTCDay()<6&&!holidays.has(d.toISOString().slice(0,10));}
function nextBusiness(d){var t=new Date(d.getTime());for(var i=0;i<15;i++){if(t.getUTCFullYear()>2027)return null;if(business(t))return t;t=add(t,1);}return null;}
function advance(d,n){var x=new Date(d.getTime());for(var i=0,count=0;i<120&&count<n;i++){x=add(x,1);if(x.getUTCFullYear()>2027)return null;if(business(x))count++;}return count===n?x:null;}
function jstDate(){var v={};new Intl.DateTimeFormat('en-US',{timeZone:'Asia/Tokyo',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date()).forEach(function(p){if(p.type!=='literal')v[p.type]=Number(p.value);});return {date:new Date(Date.UTC(v.year,v.month-1,v.day)),hour:v.hour,minute:v.minute};}
function windowForSupplier(){var time=jstDate(),d=nextBusiness(time.date);if(!d)return null;if(d.getTime()===time.date.getTime()&&time.hour>=12)d=nextBusiness(add(d,1));if(!d)return null;var first=advance(d,2),buffer=advance(d,1),last=buffer&&advance(buffer,2);return first&&last?{first:first,last:last}:null;}
function dateLabel(d){return (d.getUTCMonth()+1)+'月'+d.getUTCDate()+'日';}
function range(a,b){return a&&b&&(a.getUTCFullYear()===b.getUTCFullYear())?dateLabel(a)+(a.getTime()===b.getTime()?'':'〜'+dateLabel(b))+'ごろ':a&&b?a.getUTCFullYear()+'年'+dateLabel(a)+'〜'+b.getUTCFullYear()+'年'+dateLabel(b)+'ごろ':'';}
function provisionalTransit(p){if(p==='北海道'||p==='沖縄県')return null;var nearby=['岡山県','広島県','山口県','鳥取県','島根県','大阪府','京都府','兵庫県','滋賀県','奈良県','和歌山県','香川県','徳島県','愛媛県','高知県','福岡県','佐賀県','大分県'];var north=['青森県','岩手県','秋田県','宮城県','山形県','福島県'];return nearby.indexOf(p)!==-1?[1,4]:north.indexOf(p)!==-1?[2,6]:[2,5];}
function initialize(root){
  if(root.dataset.flatooArrivalInitialized==='true')return;
  root.dataset.flatooArrivalInitialized='true';
  var handle=root.getAttribute('data-product-handle');
  if(!handle||!/^[a-zA-Z0-9_-]{1,100}$/.test(handle))return;
  var values={};
  try{values=JSON.parse(root.querySelector('[data-flatoo-variant-state]').textContent);}catch(e){return;}
  var shipping=root.querySelector('[data-arrival-shipping]');
  var label=root.querySelector('.flatoo-arrival-safe__label');
  var destination=root.querySelector('[data-arrival-destination]');
  var select=root.querySelector('[data-arrival-prefecture]');
  var message=root.querySelector('[data-arrival-message]');
  var initialId=root.getAttribute('data-initial-variant-id');
  if(!shipping||!label||!destination||!select||!message)return;
  var commercial=Object.prototype.hasOwnProperty.call(commercialRules,handle)?commercialRules[handle]:null;
  var eligible=false;
  var manuallyChanged=false;
  var ipAutoSelected=false;
  var rememberedSelected=false;
  // An explicitly chosen prefecture is saved only in the customer's browser.
  // The IP-estimated prefecture is intentionally NOT persisted.
  var storageKey='flatoo:delivery-prefecture:v1';
  function validPrefecture(value){
    return typeof value==='string'&&!!value&&Array.prototype.some.call(select.options,function(o){return o.value===value;});
  }
  function loadRemembered(){
    try{
      var value=window.localStorage.getItem(storageKey);
      if(validPrefecture(value))return value;
      if(value!==null)window.localStorage.removeItem(storageKey);
    }catch(e){/* storage disabled, continue with IP inference */}
    return null;
  }
  function saveRemembered(value){
    try{
      if(validPrefecture(value))window.localStorage.setItem(storageKey,value);
      else window.localStorage.removeItem(storageKey);
    }catch(e){/* storage disabled: selection still works this visit */}
  }
  var section=root.closest('.shopify-section');
  var area=root.closest('.productView-options')||section;
  var fallback='1～5営業日以内発送';
  function variantId(){
    var urlId=new URLSearchParams(window.location.search).get('variant');
    if(urlId&&Object.prototype.hasOwnProperty.call(values,urlId))return urlId;
    var ids=area?area.querySelectorAll('input[name="id"]'):[];
    for(var i=0;i<ids.length;i++){if(Object.prototype.hasOwnProperty.call(values,ids[i].value))return ids[i].value;}
    return initialId;
  }
  function available(){var id=variantId();return Object.prototype.hasOwnProperty.call(values,id)&&values[id]===true;}
  function draw(){
    if(!available()){root.hidden=true;return;}
    root.hidden=false;
    if(commercial){
      message.hidden=true;
      if(commercial.mode==='S'){
        // Some shipments have an unverified factory origin (メーカー直送) or
        // use 大川配送. Do not calculate or display a calendar shipping date.
        // Preserve the product-specific published shipping lead-time policy.
        destination.hidden=true;
        label.textContent='発送までの目安';
        shipping.textContent=commercial.policy==='D'?'1～5営業日以内発送':
          commercial.policy==='B'?'5営業日目に発送':
          commercial.policy==='R'?'7～14日以内発送':'発送日数を確認中です';
        return;
      }
      var shipDates=commercialWindow(commercial.policy,commercial.cutoff);
      if(!shipDates){
        destination.hidden=true;
        label.textContent='お届け日の目安（参考試算）';
        shipping.textContent='お届け日を確認中です';
        return;
      }
      if(commercial.delivery_unverified){
        destination.hidden=true;
        label.textContent='お届け日の目安';
        shipping.textContent='配送条件を確認中です';
        return;
      }
      destination.hidden=false;
      label.textContent='お届け日の目安（参考試算）';
      if(!select.value){
        shipping.textContent='お届け先の都道府県を選択してください';
        return;
      }
      var officialTransit=officialCommercialTransit(select.value);
      shipping.textContent=officialTransit?
        range(add(shipDates.first,officialTransit[0]),add(shipDates.last,officialTransit[1])):
        '配送日数の確認が必要です';
      return;
    }
    destination.hidden=!eligible;
    label.textContent='発送までの目安';
    shipping.textContent=fallback;
    message.hidden=true;
    if(!eligible||!select.value)return;
    var span=windowForSupplier();
    var transit=provisionalTransit(select.value);
    if(!span||!transit){
      message.hidden=false;
      message.textContent='この地域のお届け日は配送条件の確認が必要です。';
      return;
    }
    label.textContent='お届け日の目安（参考試算）';
    shipping.textContent=range(add(span.first,transit[0]),add(span.last,transit[1]));
  }
  select.addEventListener('change',function(){
    manuallyChanged=true;
    ipAutoSelected=false;
    rememberedSelected=false;
    saveRemembered(select.value); // Empty selection intentionally forgets the previous choice.
    draw();
  });
  function onVariant(event){
    if(section&&event&&event.target&&event.target.nodeType===1&&!section.contains(event.target))return;
    root.hidden=true;
    window.setTimeout(draw,100);
    window.setTimeout(draw,450);
    window.setTimeout(draw,900);
  }
  document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('variant-radios,variant-selects'))onVariant(e);},true);
  document.addEventListener('variant:change',onVariant);
  document.addEventListener('variant:changed',onVariant);
  window.addEventListener('popstate',function(){window.setTimeout(draw,50);});
  draw();
  // Official-source 商材王 matches exist only in this UNPUBLISHED preview theme.
  // The live theme and API's date-publishing flags remain unchanged.
  if(commercial){
    function chooseCommercialDestination(){
      if(!commercial||commercial.mode!=='C'||commercial.delivery_unverified||manuallyChanged||select.value)return;
      var saved=loadRemembered();
      if(saved){
        select.value=saved;
        rememberedSelected=true;
        draw();
        return;
      }
      fetch(regionEndpoint+encodeURIComponent(handle),{
        method:'GET',mode:'cors',credentials:'omit',cache:'no-store',headers:{Accept:'application/json'}
      }).then(function(response){return response.ok?response.json():null;})
        .then(function(geo){
          if(manuallyChanged||select.value||!geo||geo.source!=='ip_approximate')return;
          if(!validPrefecture(geo.prefecture))return;
          select.value=geo.prefecture;
          ipAutoSelected=true;
          draw();
        }).catch(function(){/* manual selection remains available */});
    }
    // The app's saved staging rules are authoritative; no hard-coded divergence.
    // The public live theme does not include this script or staging endpoint.
    fetch(commercialEndpoint+encodeURIComponent(handle),{
      method:'GET',mode:'cors',credentials:'omit',cache:'no-store',headers:{Accept:'application/json'}
    }).then(function(response){return response.ok?response.json():null;})
      .then(function(data){
        if(!data||data.handle!==handle||data.preview_only!==true||
           (data.mode!=='C'&&data.mode!=='S')||
           ['D','B','R'].indexOf(data.policy)===-1){
          commercial=null;eligible=false;draw();return;
        }
        commercial={mode:data.mode,policy:data.policy,cutoff:data.cutoff,
                    delivery_unverified:data.delivery_unverified===true};
        draw();
        chooseCommercialDestination();
      }).catch(function(){commercial=null;eligible=false;draw();});
    return;
  }
  // HTTP 200 is a configured supplier mapping in the current, single-supplier app.
  // HTTP 404, invalid data, and API failure preserve the default text with no destination selector.
  fetch(endpoint+encodeURIComponent(handle),{method:'GET',mode:'cors',credentials:'omit',cache:'no-store',headers:{Accept:'application/json'}})
    .then(function(response){if(!response.ok)throw new Error('not_mapped');return response.json();})
    .then(function(data){
      eligible=!!(data&&data.handle===handle&&data.manual_purchase_required===true);
      if(eligible&&!manuallyChanged&&!select.value){
        var savedPrefecture=loadRemembered();
        if(savedPrefecture){
          select.value=savedPrefecture;
          rememberedSelected=true;
        }
      }
      draw();
      // A remembered customer choice always takes priority; don't even request GeoIP.
      if(!eligible||rememberedSelected||manuallyChanged||select.value)return null;
      return fetch(regionEndpoint+encodeURIComponent(handle),{
        method:'GET',mode:'cors',credentials:'omit',cache:'no-store',headers:{Accept:'application/json'}
      }).then(function(response){
        if(response.status===404){eligible=false;draw();return null;}
        return response.ok?response.json():null;
      }).catch(function(){return null;});
    })
    .then(function(geo){
      if(!geo||!eligible||manuallyChanged||select.value)return;
      if(geo.source!=='ip_approximate'||typeof geo.prefecture!=='string')return;
      var isOption=Array.prototype.some.call(select.options,function(o){return o.value===geo.prefecture;});
      if(!isOption)return;
      select.value=geo.prefecture;
      ipAutoSelected=true;
      draw();
    })
    .catch(function(){eligible=false;draw();});
}
document.querySelectorAll('[data-flatoo-arrival-safe]').forEach(initialize);
})();
